import React, { useState, useEffect } from 'react';
import './Workflow Template List.css';
import ListTable from '../../Common Components/List_Table';
import DraggableTable from '../../Common Components/Draggable_Rows_Table';
import { DragDropContext } from "react-beautiful-dnd";
import WorkflowTemplateServiceController from '../../../Controllers/WorkflowTemplateservice';
import ConfirmPopup from '../../Common Components/Confirm_Popup';
import "react-toastify/dist/ReactToastify.css";
import CustomToaster, { notify } from '../../Common Components/Custom_Toaster';
import Preview from '../../Common Components/Slide_Preview';
import Custom_InfoBar from '../../Common Components/Custom_InfoBar';
import { FaFile } from "react-icons/fa";

const WorkflowTemplateList = ({ onHandleClick, displayTemplateData, displayCloneTemplateData, toolTipData }) => {


  const workflowTempcont = new WorkflowTemplateServiceController();
  var Spinner = require('react-spinkit');
  // const tableHeading = ["", "S.No", "Workflow Name", "Client", "Department", "Date", "Created/Modified by", "Publish", "Preview","Note", ""];
  const tableHeading = ["", "S.No", "Callout Name", "Client", "Department", "Date", "Created/Modified by", "Workflow Name", "Version", "Publish", "Note", ""];

  const [workflowTableRows, setWorkflowTableRows] = useState([]);
  const [shouldReload, setShouldReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [confirmPopupData, setConfirmPopupData] = useState({
    dataId: null,
    template: '',
    popupType: '',
    name: ''
  });
  const [name, setName] = useState('');
  // Add these two states:
  const [selectedRow, setSelectedRow] = useState(null);
  const [showViewNoteModal, setShowViewNoteModal] = useState(false);

  const getJsonData = async () => {
    const body = await workflowTempcont.getWorkflowTemplateList();
    setWorkflowTableRows(
      Array.isArray(body['workflow']) && body['workflow'].length > 0
        ? body['workflow'].map((item, index) => ({
          sNo: (index + 1).toString().padStart(2, '0'),
          calloutName: item.calloutName,
          client: item.client['label'],
          department: item.department['label'],
          date: item.date ? new Date(item.date).toLocaleDateString("en-IN")  : "",
          create: item.createOrModifiedBy,
          workflowName: item.templateName,
          version: "V" + item.versionId,
          publish: item.isPublished ? "Unpublish" : "Publish",
          preview: "",
          menu: "",
          uniqueId: item.id,
          addFilterDetails: item.field,
          templateData: item.templateData,
          item: item
        }))
        : []
    );
  };
  useEffect(() => {
    const fetchData = async () => {
      setIsProcessing(true);
      await getJsonData();
      setIsProcessing(false);
      setShouldReload(false);
    }
    fetchData();
  }, [shouldReload]);

  //Function used for reordering the rows within the same table
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result.map((item, index) => ({
      ...item,
      sNo: (index + 1).toString().padStart(2, "0"),
    }));
  };

  //Function used for dragging and dropping rows(inter table and intra table)
  const handleOnDragEnd = (result) => {
    const { source, destination } = result;

    // Dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === 'listTable') {
        const reorderedList = reorder(workflowTableRows, source.index, destination.index);
        setWorkflowTableRows(reorderedList);
      }
      return;
    }
  };

  const getIsPublishedById = (uniqueId) => {
    const row = workflowTableRows.find(item => item.uniqueId === uniqueId);
    if (!row) {
      console.warn(`No workflow found with uniqueId: ${uniqueId}`);
      return null; // or false if you want a boolean default
    }
    return row.item.isPublished; // get the original isPublished value
  };

  const handleDeleteTemplate = (uniqueId) => {
    const isPublished = getIsPublishedById(uniqueId);
    if (isPublished) {
      return; // Exit the function
    }
    setIsLoading(true);
    setTimeout(async () => {
      try {
        const body = await workflowTempcont.removeDataOnWorkflowTemplateList(uniqueId);
        setIsLoading(false);
        closePopupOnFinishingApiCall();

        if (body['Success']) {
          const containsResponse = body['Response']?.includes("already mapped");
          if (containsResponse) {
            notify(body['Response'], false); // mapped case
          } else {
            notify(body['Response'], true);  // success case
          }
        } else {
          notify(
            "There was an error while performing deletion operation. Please try again later...",
            false
          );
        }
      } catch (error) {
        setIsLoading(false);
        notify(
          "An unexpected error occurred. Please try again later...",
          false
        );
        console.error(error);
      }
    }, 1000);
  };

  const handlePublishTemplate = (uniqueId, mode) => {
    setIsLoading(true);
    setTimeout(async () => {
      const body = await workflowTempcont.publishWorkflowTemplate(uniqueId, mode);
      setIsLoading(false);
      closePopupOnFinishingApiCall();
      body['Success'] ?
        notify(`${name} has been successfully published`, true) :
        notify("There was an error while performing publishing operation. Please try again later...", true);
    }, 1000)
  }

  const closePopupOnFinishingApiCall = () => {
    setIsPopupOpen(false);
    setShouldReload(true);
  }

  const openPopup = (type, id, template, name) => {
    setIsPopupOpen(!isPopupOpen);
    setConfirmPopupData(
      {
        dataId: id,
        template: template,
        popupType: type,
        name: name
      }
    )
    setName(name);
  }
  const [workflowId, setWorkflowId] = useState(1);
  const [openPreview, setOpenPreview] = useState(false);
  const [imgSource, setImgSource] = useState('');
  const openImgPreview = (id, source) => {
    setWorkflowId(id);
    setImgSource(source);
    setOpenPreview(!openPreview);
  };

  const [workflowSearchText, setWorkflowSearchText] = useState('');
  const search = (workflowSearchText || "").toLowerCase().trim();

  const filteredWorkflowTemp = Array.isArray(workflowTableRows)
    ? workflowTableRows.filter((workflow) =>
      Object.values(workflow).some((value) =>
        String(value).toLowerCase().includes(search)
      )
    )
    : [];

  const handleWorkflowSearch = (event) => {
    setWorkflowSearchText(event.target.value)
  }

  const handleWorkflowSearchClear = () => {
    setWorkflowSearchText('');
  }
  
  const editClick = (templateData, id, requestBody, workflowName) => {
    if (requestBody.isPublished) {
      notify(
        `${workflowName} is published.Edit action is disabled.`,
        false
      );
      return;
      return; // Exit the function
    }
    displayTemplateData(templateData, id, requestBody, workflowName, requestBody.field);
  }

  const cloneClick = (templateData, id, requestBody, subflowName) => {
    displayCloneTemplateData(templateData, id, requestBody, subflowName);
  }

  const handleViewNoteClick = async (row) => {
    try {
      setIsLoading(true);

      const templateId = row.uniqueId;
      const response = await workflowTempcont.getNotesByTemplateId(templateId);
      const data = await response.json(); // 👈 THIS IS REQUIRED
      setSelectedRow(data);
      setShowViewNoteModal(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const [isInfoBarVisible, setIsInfoBarVisible] = useState(true);
  const handleHideInfoBar = () => {
    setIsInfoBarVisible(!isInfoBarVisible);
  }
  return (
    <>
      <ListTable handleListClick={onHandleClick} template={true} task={false} searchText={workflowSearchText} handleSearch={handleWorkflowSearch} handleSearchClear={handleWorkflowSearchClear} />
      {
        isProcessing ?
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%' }}>

              <Spinner name="ball-spin-fade-loader" color="#02acf6" />
            </div>
          </> :
          <>
            {/* <Custom_InfoBar toolTipData={toolTipData} /> */}

            {/* DragandDropContext previously used inside the DraggableTable now elevated to the parent component */}
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <DraggableTable
                handleListClick={onHandleClick}
                openPopup={openPopup}
                editClick={editClick}
                row={filteredWorkflowTemp}
                heading={tableHeading}
                template={true}
                workflow={true}
                event={false}
                task={false}
                //getJsonValue={getJsonValue}
                droppableId="workflowlistTable"
                drag={true}
                openImgPreview={openImgPreview}
                handleNoteClick={handleViewNoteClick}
                cloneClick={cloneClick}
                searchText={workflowSearchText}
              />
            </DragDropContext>
          </>
      }

      <ConfirmPopup
        openConfirmationPopup={isPopupOpen}
        onClose={openPopup}
        handleDeleteTemplate={handleDeleteTemplate}
        handlePublishTemplate={handlePublishTemplate}
        isLoading={isLoading}
        popupData={confirmPopupData}
      />
      <Preview openPre={openPreview} closePre={openImgPreview} id={workflowId} source={imgSource} />
      <CustomToaster />
      {showViewNoteModal && selectedRow && (
        <div className="modal-overlay">
          <div className="view-notes-modal">
            <div className="view-notes-header">
              <h3>View Notes</h3>
              <button className="close-btn" onClick={() => setShowViewNoteModal(false)}>✕</button>
            </div>
            <div className="view-notes-table-wrapper">
              <table className="view-notes-table">
                <thead>
                  <tr>
                    <th>Note</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedRow?.length ? (
                    selectedRow.map((note, i) => (
                      <tr key={i}>
                        <td>{note.notes}</td>
                        <td>{note.createdBy}</td>
                        <td>{note.createdDate}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="no-note">No notes available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default WorkflowTemplateList;